import { render } from "./Historique.vue?vue&type=template&id=5e8817a3"
import script from "./Historique.vue?vue&type=script&lang=js"
export * from "./Historique.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__